// ArxiuSection.tsx
"use client";

import { Box, Typography, Button, Grid } from "@mui/material";
import { pxToVw } from "@/utils/pxToVw";
import { MOBILE_BASE } from "@/theme/theme";
import Image from "next/image";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, A11y } from "swiper/modules";
import { useText } from "@/context/TextContext";

type ArxiuItem = {
  id: string;
  num?: string;
  title?: string;
  image: string;
  width: number;
  height: number;
  alt?: string;
};

export default function ArxiuSection() {
  const ITEMS: ArxiuItem[] = [
    {
      id: "a1",
      image: useText("nosaltres.arxiu.image1"),
      alt: "Arxiu 1",
      width: 344,
      height: 449,
    },
    {
      id: "a2",
      image: useText("nosaltres.arxiu.image2"),
      alt: "Arxiu 2",
      width: 344,
      height: 147,
    },
    {
      id: "a3",
      image: useText("nosaltres.arxiu.image3"),
      alt: "Arxiu 3",
      width: 344,
      height: 449,
    },
    {
      id: "a4",
      image: useText("nosaltres.arxiu.image4"),
      alt: "Arxiu 4",
      width: 344,
      height: 405,
    },
  ];

  return (
    <Grid
      container
      mt={{ xs: pxToVw(30, MOBILE_BASE), md: pxToVw(40) }}
      mb={{ xs: pxToVw(80, MOBILE_BASE), md: pxToVw(160) }}
    >
      {/* Título */}
      <Grid container size={{ xs: 12, md: 12 }}>
        <Typography
          variant="titulo"
          color="marron"
          component="h2"
          mb={{ xs: pxToVw(10, MOBILE_BASE), md: pxToVw(10) }}
        >
          {useText("nosaltres.arxiu.title")}
        </Typography>
      </Grid>

      {/* Descripción */}
      <Grid
        container
        size={{ xs: 12, md: 12 }}
        mb={{ xs: pxToVw(30, MOBILE_BASE), md: pxToVw(20) }}
      >
        <Typography variant="body2" color="marron">
          {useText("nosaltres.arxiu.maintext")}
        </Typography>
      </Grid>

      {/* Carrusel (misma configuración que Esdeveniments) */}
      <Grid container size={{ xs: 12, md: 12 }}>
        <Swiper
          modules={[Navigation, A11y]}
          slidesPerView={4}
          spaceBetween={8}
          speed={500}
          breakpoints={{
            0: { slidesPerView: 1.2, spaceBetween: 8 },
            600: { slidesPerView: 2, spaceBetween: 8 },
            900: { slidesPerView: 4, spaceBetween: 8 },
            1200: { slidesPerView: 4, spaceBetween: 8 },
          }}
          loop
          style={{ width: "100%" }}
        >
          {ITEMS.map((item) => (
            <SwiperSlide key={item.id}>
              {/* Imagen */}
              <Box
                sx={{ width: "100%", position: "relative" }}
                mb={{ xs: pxToVw(0, MOBILE_BASE), md: pxToVw(0) }}
              >
                <Image
                  alt={item.alt || item.title || "Arxiu"}
                  src={item.image}
                  width={item.width}
                  height={item.height}
                  style={{
                    width: "100%",
                    height: "fit-content",
                  }}
                  priority={false}
                />
              </Box>

              {/* Textos debajo (número + título) */}
              <Box display="flex" flexDirection="row">
                <Grid container size={{ xs: 3, md: 4 }}>
                  <Typography variant="body5" color="warmaa">
                    {item.num}
                  </Typography>
                </Grid>
                <Grid container size={{ xs: 9, md: 8 }}>
                  <Typography variant="body5" color="warmaa">
                    {item.title}
                  </Typography>
                </Grid>
              </Box>
            </SwiperSlide>
          ))}
        </Swiper>
      </Grid>

      {/* Botón */}
      <Grid
        container
        size={{ xs: 12, md: 12 }}
        mt={{ xs: pxToVw(30, MOBILE_BASE), md: pxToVw(40) }}
      >
        <Button
          variant="botonMarron"
          id="button-nosaltres-arxiu"
          href={useText("nosaltres.arxiu.button.url")}
        >
          {useText("nosaltres.arxiu.button.text")}
        </Button>
      </Grid>
    </Grid>
  );
}
